export default __webpack_public_path__ + "f744d1fd823da5914fbdcd9e70d34784.png";